import { useState, useMemo } from 'react'
import usePermission from '../../../hooks/usePermission'

export const useSettings = () => {
    const { is, can } = usePermission()

    // Sub-tab states
    const [userlistvalue, setUserlistvalue] = useState('1')
    const [filterType, setFilterType] = useState('all')
    const [userAddvalue, setUserAddvalue] = useState('1')
    const [editData, setEditData] = useState(null)

    // Calculate available tabs first to set initial value correctly
    const allTabs = useMemo(() => [
        { label: 'User Info', value: '9', permissions: [] }, // Always visible
        { label: 'List of Users', value: '1', permissions: ['user.all', 'settings.listOfUsers', 'user.read'] },
        { label: 'Add Users', value: '2', permissions: ['user.all', 'settings.addUsers', 'user.create'] },
        { label: 'Organizations', value: '3', permissions: ['settings.organizations.read', 'organization.all'] },
        { label: 'Roles', value: '4', permissions: ['settings.roles.read', 'role.read'] },
        { label: 'Entities', value: '5', permissions: ['settings.entities.read'] },
        { label: 'Log Report', value: '6', permissions: ['settings.reports'] },
        { label: 'Change Password', value: '7', permissions: ['settings.changePassword', 'settings.changePassword.update'] },
        { label: 'Email Settings', value: '8', permissions: ['settings.emailSettings'] },
    ], [])

    const tabsToShow = useMemo(() => (is('Super Admin') || is('Admin'))
        ? allTabs
        : allTabs.filter(tab => {
            if (tab.value === '9') return true; // User Info always visible
            if (!tab.permissions || tab.permissions.length === 0) return true;
            return tab.permissions.some(p => can(p));
        }), [is, can, allTabs])

    const initialTabValue = tabsToShow.length > 0 ? tabsToShow[0].value : '9'
    const [value, setValue] = useState(initialTabValue)

    const token = localStorage.getItem('accessToken')

    const handleChange = (event, newValue) => {
        setValue(newValue)
        if (newValue !== '2') setEditData(null) // Reset edit data when leaving Add/Edit tab
    }

    const handleUserlistTabChange = (event, newValue) => {
        setUserlistvalue(newValue)
    }

    const handleUserAddTabChange = (event, newValue) => {
        setUserAddvalue(newValue)
        // Removed setEditData(null) to allow pre-filling when switching to Edit mode sub-tabs
    }

    // Setters helper for desktop/mobile consumption
    const setters = {
        setValue,
        setUserlistvalue,
        setUserAddvalue,
        setEditData
    }

    // Handlers helper
    const handlers = {
        handleChange,
        handleUserlistTabChange,
        handleUserAddTabChange
    }

    return {
        // State
        value,
        userlistvalue,
        filterType,
        userAddvalue,
        editData,
        tabsToShow,
        token,

        // Actions/Setters
        setters: {
            ...setters,
            setFilterType
        },
        handlers,

        // Utils
        is,
        can
    }
}
